var _circle, _path, _rect, _rect2, _path2, _path3, _rect3, _path4, _mask, _g, _path5, _rect4, _path6, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEligibleMemberIllu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 274,
    viewBox: "0 0 334 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 127.5,
    r: 126.5,
    fill: "#E1E1E4",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 195C3.00001 205.078 6.95089 214.744 13.9835 221.87C21.0161 228.996 30.5544 233 40.5 233C50.4456 233 59.9839 228.996 67.0165 221.87C74.0491 214.744 78 205.078 78 195L40.5 195L3 195Z",
    fill: "#91CED2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 200,
    width: 32,
    height: 32,
    fill: "#2D3E91"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 195,
    width: 38,
    height: 38,
    fill: "#FFD1CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257 231.547C267.285 231.547 277.149 227.462 284.422 220.19C291.695 212.919 295.781 203.057 295.781 192.773C295.781 182.49 291.695 172.628 284.422 165.356C277.149 158.085 267.285 154 257 154L257 192.773L257 231.547Z",
    fill: "#91CED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 160L36 194C17.2223 194 2 178.778 2 160L19 160L36 160Z",
    fill: "#F86969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 153,
    width: 38,
    height: 38,
    fill: "#FEA7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.823 64L165.265 83.7866L187.001 86.6518L171.1 101.746L175.092 123.303L155.823 112.845L136.554 123.303L140.546 101.746L124.645 86.6518L146.381 83.7866L155.823 64Z",
    fill: "#F86969"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 64,
    width: 63,
    height: 60
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.782 64L165.224 83.7866L186.96 86.6518L171.059 101.746L175.051 123.303L155.782 112.845L136.513 123.303L140.505 101.746L124.604 86.6518L146.34 83.7866L155.782 64Z",
    fill: "#F86969"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 125.5L176 70.9999C174.167 64.1666 169.6 50.6999 166 51.4999C161.5 52.4999 96.5001 73.4999 95.0001 73.9999C93.8001 74.3999 121.167 108.5 135 125.5Z",
    fill: "#FEA7A7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.532 167.534L135.705 167.406V144.661H176.984L195.47 126.324C198.813 123.008 204.211 123.03 207.527 126.373C210.866 129.74 210.817 135.184 207.417 138.49L177.547 167.534L177.539 167.541L177.532 167.534Z",
    fill: "#2D3E91"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 165.938,
    width: 33.4966,
    height: 26.0479,
    transform: "rotate(-52.7976 116 165.938)",
    fill: "#2D3E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.076 149.164C130.891 139.525 139.311 132.543 149.12 132.543H170.261C174.851 132.543 178.572 136.264 178.572 140.854C178.572 145.444 174.851 149.164 170.261 149.164H129.076Z",
    fill: "#91CED2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 146.5,
    r: 16.5,
    fill: "#BAE4E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibleMemberIllu);
export default __webpack_public_path__ + "static/media/eligible-member-illu.f5ee3715f2d86e87a9f7d8235680b999.svg";
export { ForwardRef as ReactComponent };